import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, CreditCardIcon, TruckIcon } from '@heroicons/react/20/solid';
import { BanknotesIcon } from '@heroicons/react/24/outline';

const Checkout = ({ cart, total, onBack }) => {
  const navigate = useNavigate();
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('card');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically process the order
    navigate('/food');
  };

  return (
    <div className="bg-pri-dark min-h-screen text-white">
      <div className="container mx-auto px-4 py-8">
        <button
          onClick={onBack}
          className="flex items-center text-pri-yellow mb-6 hover:text-pri-yellow-light transition-colors"
        >
          <ChevronLeftIcon className="h-5 w-5 mr-1" />
          Back to Menu
        </button>
        
        <h1 className="text-3xl font-bold mb-8 text-pri-white">Checkout</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h2 className="text-xl font-semibold mb-4 text-pri-white">Order Summary</h2>
            <div className="bg-sec-dark rounded-lg p-4 mb-6">
              {cart.map((item) => (
                <div key={item.id} className="flex justify-between items-center mb-2 text-pri-white">
                  <span>{item.name} x {item.quantity}</span>
                  <span>£{(item.price * item.quantity).toFixed(2)}</span>
                </div>
              ))}
              <div className="border-t border-gray-600 mt-4 pt-4 flex justify-between items-center font-bold text-pri-white">
                <span>Total</span>
                <span>£{total}</span>
              </div>
            </div>
          </div>
          
          <div>
            <h2 className="text-xl font-semibold mb-4 text-pri-white">Delivery Details</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="address" className="block text-sm font-medium mb-1 text-pri-white">
                  Delivery Address
                </label>
                <textarea
                  id="address"
                  rows="3"
                  className="w-full px-3 py-2 bg-sec-dark border border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-pri-yellow text-pri-white"
                  value={deliveryAddress}
                  onChange={(e) => setDeliveryAddress(e.target.value)}
                  required
                ></textarea>
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-2 text-pri-white">Payment Method</label>
                <div className="space-y-2">
                  <label className="flex items-center space-x-3 cursor-pointer">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="card"
                      checked={paymentMethod === 'card'}
                      onChange={() => setPaymentMethod('card')}
                      className="form-radio text-pri-yellow"
                    />
                    <CreditCardIcon className="h-5 w-5 text-pri-yellow" />
                    <span className="text-pri-white">Credit/Debit Card</span>
                  </label>
                  <label className="flex items-center space-x-3 cursor-pointer">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="cash"
                      checked={paymentMethod === 'cash'}
                      onChange={() => setPaymentMethod('cash')}
                      className="form-radio text-pri-yellow"
                    />
                    <BanknotesIcon className="h-5 w-5 text-pri-yellow" />
                    <span className="text-pri-white">Cash on Delivery</span>
                  </label>
                </div>
              </div>
              
              <button
                type="submit"
                className="w-full bg-pri-yellow text-pri-dark font-semibold py-3 rounded-md hover:bg-opacity-80 transition-colors duration-200 flex items-center justify-center"
              >
                <TruckIcon className="h-5 w-5 mr-2" />
                Place Order
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;